<div class="modal-header">
    <h4 class="modal-title">{{ titulo }}</h4>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="close()"></button>
</div>
<div class="modal-body text-center">
    <img [src]="imageUrl" [alt]="titulo" class="img-fluid" style="max-height: 70vh;">
</div>
<div class="modal-footer">
   <button type="button" class="btn btn-dark" (click)="downloadImage()">
        <i class="fas fa-download"></i> Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="close()">Cerrar</button>
</div>